import { SunIcon, MoonIcon } from './icons';

interface Props {
  isDark: boolean;
  onToggle: () => void;
}

export function ThemeToggle({ isDark, onToggle }: Props) {
  return (
    <button
      onClick={onToggle}
      className="min-h-[44px] min-w-[44px] flex items-center justify-center rounded-full text-atlas-ink dark:text-atlas-ink-dark transition-colors hover:bg-atlas-surface dark:hover:bg-atlas-surface-dark focus:outline-none focus:ring-2 focus:ring-atlas-brass dark:focus:ring-atlas-brass-dark"
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      title={isDark ? 'Light mode' : 'Dark mode'}
    >
      {isDark ? <SunIcon className="w-5 h-5" /> : <MoonIcon className="w-5 h-5" />}
    </button>
  );
}
